import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ClientReportHtmlGQL } from '../../../../../generated/graphql';

/** Shows a sent report, rendered from what was stored when it was sent. */
@Component({
  selector: 'app-report-html-dialog',
  templateUrl: './report-html-dialog.component.html',
  styleUrls: ['./report-html-dialog.component.scss'],
})
export class ReportHtmlDialogComponent implements OnInit {
  subject = '';
  html: SafeHtml;
  failed = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { reportId: string },
    private reportHtmlGQL: ClientReportHtmlGQL,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.reportHtmlGQL.fetch({ id: this.data.reportId }).subscribe({
      next: ({ data }) => {
        this.subject = data.clientReport?.subject || '';
        this.html = this.sanitizer.bypassSecurityTrustHtml(data.clientReport?.html || '');
      },
      error: () => (this.failed = true),
    });
  }
}
